import React from 'react'
import { Form, Select, Radio } from 'antd'
// import { withApollo } from 'react-apollo'
import _get from 'lodash/get'
// import withProps from 'recompose/withProps'
// import _keyBy from 'lodash/keyBy'
// import ticketItemQuery from '~/App/graphql/queries/ticketItem.gql'
// import raceQuery from '~/App/graphql/queries/race.gql'
// import ImageUploader from '../ImageUploader'
import { inject, observer } from 'mobx-react'
// import { FormattedMessage } from 'react-intl'
import moment from 'moment'
import bibNumber from '~/App/utils/bibNumber'
import localeGet from '~/App/utils/localeGet'
import renderQuestionInput from '~/renderQuestionInput'
// import eventSettingsFragment from '~/App/graphql/fragments/eventSettings.gql'

const formItemLayout = {
  labelCol: { sm: { span: 10 }, xs: { span: 24 } },
  wrapperCol: { sm: { span: 14 }, xs: { span: 24 } }
}
// const bankBrands = ['bbl', 'kbank', 'ktb', 'tmb', 'scb', 'citi', 'cimb', 'uob', 'bay', 'tbank', 'ibank', 'lhb']
@inject('i18n')
@Form.create()
@observer
class CancelRequestForm extends React.Component {
  render () {
    const { form, i18n: { locale }, registration } = this.props
    const { event } = registration
    const { getFieldDecorator, getFieldValue } = form
    const participants = _get(registration, 'participants', [])
    const cancelRequests = _get(registration, 'cancelRequests', [])
    const requestedTicketIds = cancelRequests.map(r => r.ticketItemId)
    const tickets = []
    participants.forEach(p => {
      p.tickets.forEach(t => {
        if (!requestedTicketIds.includes(t._id)) {
          tickets.push({
            ...t,
            participant: p
          })
        }
      })
    })
    getFieldDecorator(`record.eventId`, {
      initialValue: registration.eventId,
      rules: [{ required: true }]
    })
    getFieldDecorator(`record.registrationId`, {
      initialValue: registration._id,
      rules: [{ required: true }]
    })
    getFieldDecorator(`record.paymentId`, {
      initialValue: _get(registration, 'payment._id'),
      rules: [{ required: true }]
    })
    getFieldDecorator(`record.masterType`, {
      initialValue: 'Registration',
      rules: [{ required: true }]
    })
    getFieldDecorator(`record.masterId`, {
      initialValue: registration._id,
      rules: [{ required: true }]
    })
    
    const ticketItemDecorator = getFieldDecorator('record.ticketItemId', {
      rules: [{ required: true }],
      initialValue: tickets.length === 1 
        ? _get(tickets, [0, '_id'])
        : undefined
    })
    const methodDecorator = getFieldDecorator('record.methodId', { rules: [{ required: true }] })
    const ticketId = getFieldValue('record.ticketItemId')
    const methodId = getFieldValue('record.methodId')
    const ticket = tickets.find(t => t._id === ticketId)
    const methods = _get(ticket, 'ticketType.settings.cancelRequest.methods', [])
      .filter(o => 
        moment().isBetween(
          _get(o, 'period.start'),
          _get(o, 'period.end')
        )
      )
    const method = methods.find(o => o._id === methodId)
    const questions = _get(method, 'questions', [])
    // console.log({ options })
    return <Form>
      <h3>{{ en: 'Cancellation Request', zh: 'Cancellation Request', th: 'การขอยกเลิกการสมัคร' }[locale]}</h3>
      <Form.Item label={{ en: 'Participant', zh: 'Participant', th: 'ผู้เข้าแข่งขัน' }[locale]} {...formItemLayout} >
        {ticketItemDecorator(
          <Select>
            {tickets.map(t =>
              <Select.Option key={t._id}>
                [{bibNumber(t.number, _get(event, 'settings.ticket.numberDigits', 4))}] {' '}
                {_get(t, 'participant.profile.firstName')} {' '}
                {_get(t, 'participant.profile.lastName')}
              </Select.Option>
            )}
          </Select>
        )}
      </Form.Item>
      {ticketId && <Form.Item
        label={{ en: 'Cancellation Method', th: 'การขอยกเลิก', zh: 'Cancellation Method' }[locale]}
        extra={localeGet(method, 'extraMessage', locale)}
        {...formItemLayout}
      >
        {methodDecorator(
          <Radio.Group>
            {methods.map(o =>
              <Radio key={o._id} value={o._id}>
                <span style={{ whiteSpace: 'pre-line' }}>
                  {localeGet(o, 'name', locale)}
                </span>
              </Radio>  
            )}
          </Radio.Group>
        )}
      </Form.Item>}
      {questions.map((question, questionIndex) => {
        const optionField = {
          Open: 'value',
          Choice: 'itemId',
          MultiChoice: 'itemIds'
        }[question.kind]
        getFieldDecorator(`record.options[${questionIndex}].questionId`, {
          initialValue: question._id
        })
        const optionDecorator = getFieldDecorator(`record.options[${questionIndex}].${optionField}`, {
          rules: [{ required: question.required, message: `${localeGet(question, 'name', locale)} is Required` }]
        })
        return <Form.Item
          label={
            <span>
              {localeGet(question, 'name', locale)}
            </span>
          }
          {...formItemLayout}
          key={question._id}
        >
          {optionDecorator(renderQuestionInput({ question, locale }, () => this.modalRef))}
        </Form.Item>
      })}

    </Form>
  }
}

export default CancelRequestForm



// WEBPACK FOOTER //
// ./src/App/components/CancelRequestForm/CancelRequestForm.js